import React from 'react';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './GradientProgressBar.css'; // Arquivo de estilos

const GradientProgressBar = ({ value, txtValue }) => {
    // Interpolação do HSL mantendo o verde
    const getColor = (value, intensity = 1) => {
        const hue = 120 - (value * 120) / 100; // Verde (120) → Vermelho (0)
        return `hsl(${hue}, ${100 * intensity}%, 50%)`;
    };

    // Gradiente mantendo cores anteriores
    const getGradient = (value) => {
        const color1 = getColor(0); // Sempre começa no verde puro
        const color2 = getColor(value * 0.5, 0.8); // Tom intermediário mais claro
        const color3 = getColor(value, 1); // Cor do progresso atual

        return `linear-gradient(to right, ${color1}, ${color2}, ${color3})`;
    };

    return (
        <Container className="mt-4 mb-4">
            <p className="text-center">
                <b>
                    Porcentagem de ultrapassagem prevista até o final desse ano
                </b>
                :
            </p>
            <div className="progress-container">
                <div
                    className="progress-bar-custom"
                    style={{
                        width: `${value}%`,
                        background: getGradient(value),
                    }}
                ></div>
                <span className="progress-text">{txtValue.toFixed(2)}%</span>
            </div>
        </Container>
    );
};

export default GradientProgressBar;
